import { Link, Outlet } from "react-router-dom";
import "./ChooseDesForLoggedInUser.css";
import axios from "axios";
import api from "../../Login and Sign UP/api";
let ChooseDesForLoggedInUser=(props)=>{
    let DesignesClickFun=async(e)=>{
        let mydesignesformdata = new FormData();
        mydesignesformdata.append('deslink', e.deslink);
        mydesignesformdata.append('userid', props.id);
        mydesignesformdata.append('desid', e.id);
        mydesignesformdata.append('desimage', e.desimage);
        mydesignesformdata.append('description',e.description);
        mydesignesformdata.append('alt',e.alt);
       try {
               const response = await api.post('/myresumes.php', mydesignesformdata);
           } catch (error) {
               console.log(error.message)
               
           }
       
    }
    return(
    <div className='designss'>
        <p style={{textAlign:"center",width:"100%", fontSize:"25px",padding:"1.5px", margin:"0", borderBottom:"3px solid black"}}>Choose Your Resume Designe</p>
        <div className='designs_main_cont'>
            {
                props.AllDesigns.map(
                    deslink=>(
                        <Link onClick={()=>DesignesClickFun(deslink)} to={'../'+deslink.deslink}  title='Dseignes' className='desi_cont'>
                            
                            <img className='image' alt={deslink.alt} src={deslink.desimage}/>
                            <p className='imghead'>{deslink.description}</p>
                        </Link>
                        
                    )
                )
            }
        </div>
    </div>
);
    

}
export default ChooseDesForLoggedInUser;